class pgweb.Login
	
	instance = null
	
	@inst: ->
		if not instance?
			instance = new @
			instance.init()
		instance

	init: ->
		u = pgwebGetCookie 'auth_version'
		newAuth = false
		if u
			if u > 0
				newAuth = true
		if not newAuth
			@forgetCredentials()
		pgwebSetCookie 'auth_version', '1'

		if $.mobile?
			if $.mobile.activePage and $.mobile.activePage[0].id is "loginPage" and @usernameFromCookie()
				@displayCredentials()
		
		$('body').on 'pageshow', '#loginPage', (event) =>
			if @usernameFromCookie()
				@displayCredentials()

		$('body').on 'click', '#loginButton', (event) =>
			@onLoginButtonClick event

		$('body').on 'click', '#logoutButton', (event) =>
			@onLogoutButtonClick event
			
		$('body').on 'click', '#send-new-password-button', (event) =>
			@onSendNewPasswordLinkClick event

	# Take credentials from cookies and display them in the form.
	displayCredentials: ->
		node = $.mobile.activePage.find "[name=pgweb_username]"
		node.val @usernameFromCookie()

		node = $.mobile.activePage.find "[name=pgweb_password]"
		node.val @passwordFromCookie()

		node = $.mobile.activePage.find "[name=remember]"
		node.attr "checked", "checked"
		node.checkboxradio "refresh"

	onLoginButtonClick: (event) ->
		username = $("#pgweb_username").val().trim().toLowerCase()
		password = $("#pgweb_password").val()
		try
			validateMessages = @loginValidate username, password
			if validateMessages.length > 0 then throw "VALIDATE_ERROR"

			@ajaxLogin username, password
			
			rememberCredentialsChecked = $('.ui-page-active [name=remember]')[0].checked
			if rememberCredentialsChecked
				@rememberCredentials username, password
			else
				@forgetCredentials()
		catch ex
			switch ex
				when "VALIDATE_ERROR" then errorMessage validateMessages.join "<br />"
				else alert ex.message
		event.preventDefault()
		window.setTimeout (->
			$('#login-form .ui-btn-active').removeClass "ui-btn-active"
		), 500

	onSendNewPasswordLinkClick: ->
		username = $("#pgweb_username").val()
		try
			if !username then throw "VALIDATE_ERROR"
			@ajaxSendNewPasswordLink username
		catch ex
			switch ex
				when "VALIDATE_ERROR" then errorMessage t.LoginPage_EnterUsername
		event.preventDefault()

	loginValidate: (username, password) ->
		s = []
		if username is "" then s.push t.LoginPage_EnterUsername
		if password is "" then s.push t.LoginPage_EnterPassword
		s

	onLogoutButtonClick: (event) ->
		@ajaxLogout()
		event.preventDefault()

	rememberCredentials: (username, password) ->
		@usernameToCookie username
		@passwordToCookie password

	forgetCredentials: ->
		$.removeCookie 'pgweb_username', path: '/'
		$.removeCookie 'pgweb_password', path: '/'

	usernameFromCookie: ->
		@deobf pgwebGetCookie 'username'

	passwordFromCookie: ->
		@deobf pgwebGetCookie 'password'

	usernameToCookie: (username) ->
		pgwebSetCookie 'username', (@obf username), 90

	passwordToCookie: (password) ->
		pgwebSetCookie 'password', (@obf password), 90

	obf: (txt) ->
		btoa txt

	deobf: (txt) ->
		if txt 
			atob txt
		else ''

	ajaxLogin: (username, password) ->
		waitStart()
		$.ajax
			url: "/pgweb/ajax/user/login.php"
			dataType: 'json'
			type: 'POST'
			data:
				username: username
				password: password
			success: (data) ->
				switch data.result
					when "OK"
						pgwebSetCookie 'idHash', data.idHash, 90
						#$.mobile.changePage $.url().attr('source'), reloadPage: true
						if not pgweb.Main.passwordStrengthIsOK password
							alert(t.PasswordWarningNotSecure)
						redirectUrl = $('#login-redirect').val()
						window.location = redirectUrl or $.url().attr('source')
					when "LOGIN_FAILED"
						errorMessage t.LoginPage_InvalidCredentials
					else errorMessage "Login failed: "+data.debug
			error: ajaxFailure
			complete: waitStop

	ajaxLogout: ->
		waitStart()
		$.ajax
			url: "/pgweb/ajax/user/logout.php"
			dataType: 'json'
			success: (data) ->
				switch data.result
					when "OK"
						pgwebRemoveCookie 'idHash'
						window.location = $.url().attr('source')
					else alert "Logout failed: "+data.debug
			error: ajaxFailure
			complete: -> waitStop()

	ajaxSendNewPasswordLink: (username) ->
		waitStart()
		$.ajax
			url: "/pgweb/ajax/user/sendNewPasswordLink.php"
			dataType: 'json'
			type: 'POST'
			data:
				username: username
			success: (data) ->
				switch data.result
					when "OK"
						infoMessage t.LoginPage_NewPasswordMailSent
						$('#forgot-password-panel').trigger 'collapse'
					else errorMessage "Failed to send new password: "+data.debug
			error: ajaxFailure
			complete: -> waitStop()

	isSuperAdmin: ->
		# Computed server-side from config.edn :super-admins.
		pgweb.isSuperAdmin == true

$(-> pgweb.Login.inst())
